module.exports = __webpack_public_path__ + "img/logo.768def45.png";